import { Icons } from 'pages/Workshop/Icons';
import { projectsFilters } from 'settings/constants/roles';

export const projectTypes = {
  MyProjects: 'My Transactions',
  AllProjects: 'All Transactions',
};

export const dropdownFields = [
  { itemValue: projectsFilters.myProjects, icon: Icons.USER },
  { itemValue: projectsFilters.allProjects, icon: Icons.TEAM_USER },
];

// export const dropdownFields = (isAdminOrOwner) => {
//   return [
//     { itemValue: projectsFilters.myProjects, icon: Icons.USER, iconColor: '#04a451' },
//     ...(isAdminOrOwner
//       ? [{ itemValue: projectsFilters.teamProjects, icon: Icons.TEAM_USER, iconColor: '#04a451' }]
//       : []),
//     { itemValue: projectsFilters.externalProjects, icon: Icons.INVITE_USER },
//   ];
// };

export const getDefaultProjectTeamFilterValue = () => {
  return dropdownFields[1];
};
